/* eslint-disable no-console */
function init() {}

function log() {
  var _console;

  (_console = console).log.apply(_console, arguments);
}

function info() {
  var _console2;

  (_console2 = console).info.apply(_console2, arguments);
}

function error() {
  var _console3;

  (_console3 = console).error.apply(_console3, arguments);
}

export default {
  init: init,
  log: log,
  info: info,
  error: error
};